import { configureStore } from '@reduxjs/toolkit';
import supervisorSlice from './supervisorSlice';
import parametersSlice from './parametersSlice';
import chatSlice from './chatSlice';

const store = configureStore({
    reducer: {
        supervisor: supervisorSlice,
        parameters: parametersSlice,
        chat: chatSlice
    }
});
export default store;